import { WarehouseInfos } from "models/PlanInfos";
import { JSX } from "react";
import { IDataDisplayer } from "./DataDisplayer";

export class DataDisplayerService {
  private dataDisplayerAdapter: IDataDisplayer;

  constructor(dataDisplayType: IDataDisplayer) {
    this.dataDisplayerAdapter = dataDisplayType;
  }

  initialisePlan() {
    this.dataDisplayerAdapter.initialisePlan();
  }

  updatePlan(plan: WarehouseInfos): void {
    this.dataDisplayerAdapter.updateWarehousePlan(plan);
  }

  renderDisplayer(): JSX.Element {
    return this.dataDisplayerAdapter.renderDisplayer();
  }
}
